export default __webpack_public_path__ + "assets/77b41b.svg";